import React from 'react';
import { RouteProps } from 'react-router';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from './AuthContext';

export const ProtectedRoute: React.FC<RouteProps> = (props) => {
  const { user } = useAuth();
  const { children, ...routeProps } = props;

  return <Route {...routeProps}>{user != null ? children : <Redirect to="/" />}</Route>;
};
